import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchCustomerTracking = (id) =>
  apiActionCreator({
    'endpoint': `/vehicles/customer-tracking/${id}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_CUSTOMER_TRACKING,
      ActionTypes.FETCHED_CUSTOMER_TRACKING,
      [
        ActionTypes.FETCHED_CUSTOMER_TRACKING_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const clearCustomerTrackingState = () => ({
  'type': ActionTypes.CLEAN_CUSTOMER_TRACKING_STATE,
  'payload': null,
});
